import { type FC } from 'react'
import { Form } from 'react-bootstrap'
import { InfoTooltip } from '../../../../Scheduling/shared/InfoTooltip'
import { type SchedulingEventType } from '../../../../../models/Scheduling'

interface PlacementSectionProps {
  draft: SchedulingEventType
  disabled: boolean
  onDraftChange: (patch: Partial<SchedulingEventType>) => void
}

export const PlacementSection: FC<PlacementSectionProps> = ({ draft, disabled, onDraftChange }) => (
  <div className='d-flex flex-column zocks-gap-0.5'>
    <div className='lead-small zocks-text-gray-600'>Placement</div>
    <div className='d-flex flex-column border rounded-1 zocks-border-color-gray-300'>
      <div className='d-flex align-items-center justify-content-between zocks-gap-0.5 px-3 py-2 border-bottom zocks-border-color-gray-300'>
        <span className='d-flex align-items-center zocks-gap-0.25 paragraph-small'>
          Add to user pages by default
          <InfoTooltip
            title='New users get this event type on their booking page automatically.'
            label='About adding to user pages by default'
            className='zocks-text-gray-900'
          />
        </span>
        <Form.Switch
          checked={draft.addToUserPagesByDefault}
          disabled={disabled}
          aria-label='Add to user pages by default'
          onChange={(event) => onDraftChange({ addToUserPagesByDefault: event.currentTarget.checked })}
        />
      </div>
      <div className='d-flex align-items-center justify-content-between zocks-gap-0.5 px-3 py-2'>
        <span className='paragraph-small zocks-text-gray-400'>Show on firm booking page</span>
        <span className='badge rounded-2 zocks-bg-color-warning zocks-text-gray-900'>Coming soon</span>
      </div>
    </div>
  </div>
)
